module.exports = __webpack_public_path__ + "static/img/kjdy07.e5b7e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy07.png
// module id = 26
// module chunks = 0